import React, { useEffect, useState } from 'react'

const Timer = ({ futureDate, onComplete }) => {
  const [remainingTime, setRemainingTime] = useState(0)

  useEffect(() => {
    const intervalId = setInterval(updateRemainingTime, 1000)
    const initialRemainingTime =
      new Date(futureDate).getTime() - new Date().getTime()
    setRemainingTime(initialRemainingTime)

    return () => {
      clearInterval(intervalId)
    }
  }, [futureDate])

  const updateRemainingTime = () => {
    const updatedRemainingTime =
      new Date(futureDate).getTime() - new Date().getTime()
    setRemainingTime(updatedRemainingTime)
  }

  const formatTime = time => {
    const days = Math.floor(time / (24 * 60 * 60))
    const hours = Math.floor((time % (24 * 60 * 60)) / (60 * 60))
    const minutes = Math.floor((time % (60 * 60)) / 60)

    let formattedTime = ''

    if (days > 0) {
      formattedTime += `${days} day${days > 1 ? 's' : ''} `
    }
    if (hours > 0) {
      formattedTime += `${hours} hour${hours > 1 ? 's' : ''} `
    }
    if (minutes > 0) {
      formattedTime += `${minutes} minute${minutes > 1 ? 's' : ''} `
    }
    return formattedTime.trim()
  }

  useEffect(() => {
    if (remainingTime <= 0) {
      // onComplete()
    }
  }, [remainingTime])

  const formattedTimes = formatTime(Math.floor(remainingTime / 1000))

  return <p className='animate-pulse text-red-500'>{formattedTimes}</p>
}

export default Timer
